// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"db76a509","427":"6eb8de25","436":"b9a7a706","910":"bc97fd4e"}[chunkId] + ".chunk.js";
};